import { toast } from 'react-toastify';
import axios from 'utils/AxiosConfig'
export const postWithoutTokenFunciton = async (url: string, data: any) => {
  try {
    const res = await axios
      .post(url, data)
      .then(function (response) {
        return {
          data: response.data,
        }
      })
      .catch(function (error) {
        if (error.response != null) {
          console.log('--- POST response ---', error.response);
          if (error.response.status === 401) {
            return {
              error: 'Token exprired',
            }
          }
          if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
            return {
              data: {
                error: error.response.data.message,
                message: error.response.data.message,
              },
            }
          }

          if (error?.response?.data?.data?.error) {
            toast.error(error?.response?.data?.data?.error);
          }

          return {
            error: error.response.data.data,
          }
        }
        return {
          error: error.response,
        }
      })
    return res
  } catch (er) {}
}

export const getFunciton = async (url: string) => {
  try {
    //const accessToken="";
    const res = await axios
      .get(url)
      .then(function (response) {
        return {
          data: response.data,
        }
      })
      .catch(function (error) {
        //console.log("fetch get function error",error)
        if (error.response != null && error.response.status === 401) {
          //console.log("token exprired")
          return {
            error: 'token exprired',
          }
        }
        return {
          error: error.message[0],
        }
      })
    return res
  } catch (er) {}
}
